import mrpStyles from './../mrp.json'

export default {
  name: 'A3',
  type: 'Heading',
  color: mrpStyles.colors.PrimaryBlack,
  inverseColor: mrpStyles.colors.PrimaryWhite
}
